import { OcrResult } from "@finway-group/shared/lib/models"
import axios from "axios"

import ConfirmOCRChangesModal from "Components/modals/confirmOCRChanges.modal"
import { checkForDuplicate, isHospitalityExpense } from "Features/pages/expenses/expenseUtils"
import { compareFormOcrData, mergeExistingAndOcrItems } from "Shared/utils/ocr.utils"
import { RunOcrParams } from "Shared/utils/ocr.utils.types"

import NotificationService from "./notification.service"

const OcrService = {
    uploadAndRetrieve: async (requestData: { filePath: string; isHospitality: boolean; ocrItemizationEnabled: boolean; isOcrRetrigger: boolean; meta?: object }) => {
        const { data } = await axios.post("ocr", requestData)
        return data.ocrObject as OcrResult
    },
    runOcr: async ({
        invoiceUrl,
        expense,
        setIsOcrUploading,
        vendors,
        t,
        noDataDifferenceFunction,
        setUpdatedObject,
        showModal,
        language,
        isOcrItemizationEnabled,
        meta,
        showOcrDifferencesModal = true,
        isOcrRetrigger = false,
    }: RunOcrParams) => {
        try {
            setIsOcrUploading(true)

            const isHospitality = isHospitalityExpense(expense)
            const ocrItemizationEnabled = isOcrItemizationEnabled || isHospitality

            const ocrObject = await OcrService.uploadAndRetrieve({ filePath: invoiceUrl, isHospitality, ocrItemizationEnabled, isOcrRetrigger, meta })

            if (!isOcrRetrigger && ocrObject.invoiceNumber) {
                if (!(await checkForDuplicate(expense, ocrObject.invoiceNumber))) delete ocrObject.invoiceNumber
            }

            const formOCRDataDifferences = compareFormOcrData({ expense, ocrObject, vendors, t }, language)

            const shouldNotShowDifferencesModal = !formOCRDataDifferences || !showOcrDifferencesModal

            if (shouldNotShowDifferencesModal) {
                const ocrObjectWithUpdatedSplits = ocrObject.splits ? { ...ocrObject, splits: mergeExistingAndOcrItems(expense.splits, ocrObject.splits) } : { ...ocrObject }
                return noDataDifferenceFunction(ocrObjectWithUpdatedSplits)
            }

            showModal(ConfirmOCRChangesModal, true, {
                isShowing: true,
                expense,
                ocrObject,
                formOCRDataDifferences,
                onClose: () => {},
                setUpdatedObject,
            })
        } catch (err) {
            NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:ocr.title"))
        } finally {
            setIsOcrUploading(false)
        }
    },
}

export default OcrService
